import options from './options';

const root = {
	options
};

export default root;
